/*eslint-disable import/default, import/namespace, import/no-named-as-default, import/no-named-as-default-member */
import React from 'react';
import ReactMarkdown from 'react-markdown';
import tips from '../../data/tips.json';
import {testAnswers, testStats, testSuggestion} from '../../utils/checks'


const Tips = (props) => {
  function testSuggestion(suggestion) {
    return testAnswers(props, suggestion.criteria) || testStats(props, suggestion.criteria);
  }

  function sentenceFor(suggestion, index) {
    return <li key={index} className="results__list__item"><ReactMarkdown source={suggestion.text} /></li>;
  }

  const sentences = tips.filter(testSuggestion).map(sentenceFor);

  if (sentences.length === 0) {
    return null;
  }

  return (
    <div className="results__list">
      <div className="results__list__title">Did you know?</div>
      <ul>
        {sentences}
      </ul>
    </div>
  );
};

Tips.propTypes = {
  answers: React.PropTypes.object,
  stats: React.PropTypes.object
};

export default Tips;



// WEBPACK FOOTER //
// ./src/components/results/Tips.js